module.exports = __webpack_public_path__ + "static/media/scene_bookshelves.da2fafce.jpg";